export default "__VITE_ASSET__61b1ca65__"